<template>
    <div class="loading">
        <div class="circular-loader"></div>
    </div>
</template>

<script>
    export default {
        name: "LoadingPage",
        created() {
            this.$scrollTo(`body`, 50);
        }
    }
</script>

<style lang="scss" scoped>

</style>